import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { defineStore } from 'pinia';
import { computed, reactive, toRefs, unref } from 'vue';
import { api } from '@/server';
import { modal } from '@/share/components';
export const useAIReasonCreateKpiForm = defineStore('aiReasonCreateKpiForm', () => {
  const state = reactive({
    projKpiInfo: {
      id: '',
      name: ''
    },
    kpiItemInfo: {
      id: '',
      name: '',
      scoreWeight: 0.0
    },
    projId: '',
    itemId: '',
    sumWeight: 0.0,
    discache: false,
    reasoning: '',
    reasonId: '',
    rows: [],
    reasonError: '',
    step: 0,
    showTable: false,
    selectedRowKeys: [],
    loading: false
  });
  const {
    runAsync: getProjKpiDetailApi
  } = fetchApi(api.kpi.projKpi.getDetail, {
    showError: false
  });
  const {
    runAsync: getKpiItemDetailApi
  } = fetchApi(api.kpi.projKpiItem.getDetail, {
    showError: false
  });
  const {
    runAsync: aiReasonerKpiItems
  } = fetchApi(api.kpi.projKpi.aiReasonerItems, {
    showError: false
  });
  const getProjKpiDetail = async projId => {
    if (!projId) return;
    const {
      error,
      ...res
    } = await getProjKpiDetailApi({
      id: projId
    });
    if (error) {
      modal.message.error(error);
      return;
    }
    state.projId = projId;
    state.projKpiInfo = {
      ...res
    };
  };
  const getKpiItemDetail = async itemId => {
    if (!itemId) return;
    const {
      error,
      ...res
    } = await getKpiItemDetailApi({
      id: itemId
    });
    if (error) {
      modal.message.error(error);
      return;
    }
    state.itemId = itemId;
    state.kpiItemInfo = {
      ...res
    };
    state.sumWeight = res.scoreWeight || 0.0;
  };
  const resetForm = () => {
    state.projKpiInfo = {
      id: '',
      name: ''
    };
    state.kpiItemInfo = {
      id: '',
      name: '',
      scoreWeight: 0.0
    };
    state.projId = '';
    state.itemId = '';
    state.sumWeight = 0.0;
    state.reasonError = '';
    state.rows = [];
    state.step = 0;
    state.reasoning = '';
    state.reasonId = '';
    state.showTable = false;
    state.selectedRowKeys = [];
  };
  const createAIReasonForm = async (projId, itemId) => {
    state.step = 0;
    state.showTable = false;
    state.discache = false;
    state.loading = true;
    if (projId !== state.projId || itemId !== state.itemId) {
      resetForm();
      await getProjKpiDetail(projId);
      await getKpiItemDetail(itemId);
      state.loading = false;
    } else {
      state.loading = false;
    }
  };
  const startReasoner = async () => {
    state.step = 1;
    const {
      error,
      rows: reasonerRows = [],
      reasonId = '',
      reasoning,
      sumWeight = 0.0
    } = await aiReasonerKpiItems({
      projId: state.projId,
      itemId: state.itemId,
      sumWeight: state.sumWeight,
      discache: state.discache
    });
    if (error) {
      state.reasonError = error;
      state.step = 2;
      return;
    }
    state.reasonError = '';
    state.sumWeight = sumWeight || 0.0;
    state.rows = reasonerRows;
    state.reasonId = reasonId;
    const reg = /同时，检查JSON结构是否正确，使用rows作为根节点，.*$/ig;
    state.reasoning = reasoning.replace(reg, '');
    state.step = 2;
  };
  const queryParams = () => {
    return {
      projId: state.projId,
      itemId: state.itemId,
      sumWeight: state.sumWeight
    };
  };
  const updateSelections = selectedRowKeys => {
    state.selectedRowKeys = selectedRowKeys;
  };

  // selectAll 全选
  const selectAll = () => {
    state.selectedRowKeys = state.rows.map(row => row.id);
  };

  // unselectAll 取消全选
  const unselectAll = () => {
    state.selectedRowKeys = [];
  };

  // reverseSelect 反选
  const reverseSelect = () => {
    const selectedKeyMaps = state.selectedRowKeys.reduce((prev, id) => {
      prev[id] = true;
      return prev;
    }, {});
    const selectedKeys = [];
    for (const row of state.rows) {
      if (!selectedKeyMaps[row.id]) {
        selectedKeys.push(row.id);
      }
    }
    state.selectedRowKeys = selectedKeys;
  };

  // isSelected 是否有选中项
  const isSelected = computed(() => state.selectedRowKeys.length > 0);
  const getSelectedRows = () => {
    const selectKeysMap = state.selectedRowKeys.reduce((prev, id) => {
      prev[id] = true;
      return prev;
    }, {});
    const selectedRows = [];
    const unselectedRows = [];
    for (const row of state.rows) {
      if (selectKeysMap[row.id]) {
        selectedRows.push({
          ...unref(row)
        });
      } else {
        unselectedRows.push({
          ...unref(row)
        });
      }
    }
    return {
      selectedRows,
      unselectedRows
    };
  };
  const {
    runAsync: saveReasonerItems
  } = fetchApi(api.kpi.projKpi.saveReasonerItems, {
    showError: false
  });
  const createItemsBySelected = async () => {
    const {
      selectedRows,
      unselectedRows
    } = getSelectedRows();
    if (!isSelected.value) {
      modal.message.warning('请选择要创建的指标项');
      return false;
    }
    const postData = {
      projId: state.projId,
      itemId: state.itemId,
      rows: selectedRows
    };
    const {
      error
    } = await saveReasonerItems(postData);
    if (error) {
      modal.notification.error(error, '保存指标项失败');
      return false;
    }
    modal.notification.success('保存AI生成的指标项成功', '保存指标');
    state.rows = unselectedRows;
    return true;
  };
  const showReasonResult = () => {
    state.showTable = true;
    state.step = 0;
  };
  return {
    ...toRefs(state),
    isSelected,
    queryParams,
    getKpiItemDetail,
    getProjKpiDetail,
    getSelectedRows,
    createItemsBySelected,
    updateSelections,
    resetForm,
    startReasoner,
    selectAll,
    unselectAll,
    reverseSelect,
    showReasonResult,
    createAIReasonForm
  };
}, {
  persist: {
    enabled: true,
    key: 'kpi-ai-reason-create-form',
    storage: localStorage
  }
});